import { TFunction } from 'i18next';
import { OptionProps } from '../types';
import {Book, Competition, Project} from '@brg/api';
import { bTag } from 'core';

export const getEnumOptions = (enumObj: any, t: TFunction<"translation">): OptionProps[]=> {
    if(!Object.keys(enumObj).length) {
        return []
    }
    return Object.keys(enumObj)
        .filter((enumItem: any) => isNaN(Number(enumItem)))
        .sort()
        .map((enumItem: any) => ({
            name: t(`competition.statuses.${enumItem}`), identifier: enumObj[enumItem]
        }))
}

export const findOption = (options: OptionProps[], selectedKey: any) => {
    return options.find((optionItem: OptionProps) => optionItem.identifier === selectedKey)
}

export const getCompetitionTitle = (competition?: Competition<'Local'>) => {
    if (!competition) return
    if (competition) {
        if (competition?.title) {
            return competition?.title;
        }

        return [ ...competition?.requredTags, ...competition?.regularTags ]
            ?.map(x => bTag.title(x))
            ?.join(', ');
    }

    return null;
};

export const getCompetitionExamResults = (project: Project<'Local'> | Book<'Local'>, competition: Competition<'Local'>, ) => {
    // @ts-ignore
    return project?.competitonsGPA?.find(competitionGPA => competitionGPA?.competitionId === competition?.competitionId)?.competitionGPA || 0;
};import { TFunction } from 'i18next';
import { OptionProps } from '../types';
import {Book, Competition, Project} from '@brg/api';
import { bTag } from 'core';

export const getEnumOptions = (enumObj: any, t: TFunction<"translation">): OptionProps[]=> {
    if(!Object.keys(enumObj).length) {
        return []
    }
    return Object.keys(enumObj)
        .filter((enumItem: any) => isNaN(Number(enumItem)))
        .sort()
        .map((enumItem: any) => ({
            name: t(`competition.statuses.${enumItem}`), identifier: enumObj[enumItem]
        }))
}

export const findOption = (options: OptionProps[], selectedKey: any) => {
    return options.find((optionItem: OptionProps) => optionItem.identifier === selectedKey)
}

export const getCompetitionTitle = (competition?: Competition<'Local'>) => {
    if (!competition) return
    if (competition) {
        if (competition?.title) {
            return competition?.title;
        }

        return [ ...competition?.requredTags, ...competition?.regularTags ]
            ?.map(x => bTag.title(x))
            ?.join(', ');
    }

    return null;
};

export const getCompetitionExamResults = (project: Project<'Local'> | Book<'Local'>, competition: Competition<'Local'>, ) => {
    // @ts-ignore
    return project?.competitonsGPA?.find(competitionGPA => competitionGPA?.competitionId === competition?.competitionId)?.competitionGPA || 0;
};